var _path, _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgCustomInitLogo = function SvgCustomInitLogo(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "custom-init-logo_svg__mask0_318_19824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "#FF0606"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom-init-logo_svg__mask0_318_19824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 31.2498C34.0238 31.2498 34.5834 31.8096 34.5836 32.4998C34.5836 33.1901 34.0238 33.7497 33.3336 33.7498H4.99958C4.30944 33.7495 3.74958 33.1899 3.74958 32.4998C3.74971 31.8097 4.30953 31.25 4.99958 31.2498H33.3336ZM7.19293 27.908L4.63629 28.6814C4.34215 28.7703 4.02253 28.6897 3.80524 28.4724C3.5881 28.2552 3.5084 27.9364 3.59723 27.6423L4.36969 25.0847L7.19293 27.908ZM23.0035 6.4519C23.7831 5.6723 25.0471 5.67235 25.8267 6.4519C26.6064 7.23154 26.6064 8.49551 25.8267 9.27515L8.32282 26.7791L5.49958 23.9558L23.0035 6.4519ZM31.981 14.7136L36.2857 16.6755L31.982 18.6326L30.0211 22.9255L28.0591 18.6326L23.7593 16.6765L28.0601 14.7146L30.0211 10.4216L31.981 14.7136ZM34.9556 6.87378L36.6519 7.64624L34.9556 8.41675L34.1832 10.1082L33.4107 8.41675L31.7173 7.64624L33.4107 6.87378L34.1832 5.18237L34.9556 6.87378Z",
    fill: "url(#".concat(_id, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 45.8911,
    y1: 10.8503,
    x2: 4.89909,
    y2: 40.3495,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C66FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3377FF"
  })))));
};
export default SvgCustomInitLogo;